import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../services/data/data.service';

@Injectable({
  providedIn: 'root'
})
export class ShowIconsGuard implements CanActivate {
  constructor(
    private dataService: DataService,
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {


    route.data.application === 'admin' ?
      this.dataService.showIcons$.next(false) :
      this.dataService.showIcons$.next(true);

    return true;
  }

}
